/** What a Filings screen says when no filing has been determined: what is needed first, with the one
 * link that starts it (KD, 2026-11-02).
 *
 * A company comes first (nothing is owed by nobody); with a company, its facts are what a
 * determination reads. It is an Admin's to do, so another role is told whose job it is and offered no
 * control (design rule 6). Shared by the Filings place and Past filings, which say the same thing about
 * the same fact.
 */

import { Flag } from "@phosphor-icons/react";

import { useMe } from "../../api/auth";
import { useEntities } from "../../api/queries";
import { EmptyAction } from "../../components/ui/EmptyAction";
import { EmptyState } from "../../components/ui/EmptyState";
import { keepSearch } from "../search";
import type { ScreenSearch } from "../search";

export function NoObligations({ title = "No filing determined yet" }: { title?: string }) {
  const role = useMe().data?.role;
  const entities = useEntities();
  const noCompany = entities.data?.length === 0;
  return (
    <EmptyState
      icon={Flag}
      title={title}
      compact
      testId="no-obligations"
      action={
        <EmptyAction
          label={noCompany ? "Add a company" : "State company facts"}
          allowed={role === undefined || entities.data === undefined ? undefined : role === "admin"}
          reason="An Admin states company facts."
          to={noCompany ? "/facilities" : "/financials"}
          search={(prev: Partial<ScreenSearch>) => ({
            ...keepSearch(prev),
            ...(noCompany ? { tab: "companies" } : {}),
          })}
          plus={false}
          testId="no-obligations-start"
        />
      }
    >
      A filing starts from your company facts and sites.
    </EmptyState>
  );
}
